<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card(min-height="90vh")
      v-card-title.pa-4
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center {{ $t('edit_fundraiser') }}
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-close
      v-divider
      v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-8'")
        div.text-sm.font-semibold.neutral500--text {{ $t('name') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="fundraiser.name" outlined background-color="neutral300" readonly hide-details="auto")
        div.text-sm.font-semibold.neutral500--text.mt-4  {{ $t('raised') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="fundraiser.raised" :prefix="$currency.symbol" outlined background-color="neutral300" readonly hide-details="auto")
        div.text-sm.font-semibold.neutral500--text.mt-4  {{ $t('phone_number') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="fundraiser.phone" outlined background-color="neutral300" readonly hide-details="auto")
        div.text-sm.font-semibold.neutral500--text.mt-4  {{ $t('email') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="fundraiser.email" outlined background-color="neutral300" readonly hide-details="auto")
        div.text-sm.font-semibold.neutral500--text.mt-4  {{ $t('commission') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="fundraiser.commission" suffix="%" type="number" outlined min="0" :rules="rules.not_empty_commission" hide-details="auto")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-btn.button-md.neutral700--text.px-0(@click="closeDialog" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md(:loading="isLoading" color="neutral700" depressed dark @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EditFundraiser',
  components: {},
  props: ['open', 'selectedFundraiser'],
  data () {
    return {
      isFetching: false,
      isLoading: false,
      fundraiser: {},
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        not_empty_commission: [val => (!!val || val === 0)|| 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.fundraiser = {
        name: this.selectedFundraiser.user.first_name + this.selectedFundraiser.user.last_name,
        raised: this.selectedFundraiser.raised / this.$currency.multiplier,
        phone: this.selectedFundraiser.phone,
        email: this.selectedFundraiser.user.email,
        commission: this.selectedFundraiser.tier ? this.selectedFundraiser.tier.commission_value : 0
      }
    },
    saveData () {
      this.isLoading = true
      const data = { commission_value: this.fundraiser.commission }
      this.$axios.patch(`/donations/${this.company.slug}/fundraisers/${this.selectedFundraiser.id}`, data)
        .then(() => {
          this.$emit('reset')
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>